module.exports = __webpack_public_path__ + "img/paper_plus.d137b9cd.svg";